import { createIcon } from '@chakra-ui/icons';

export const EditCompact = createIcon({
  displayName: 'EditCompact',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.125 8.75024C12.6 8.75024 12.25 9.10024 12.25 9.62524V12.2502H1.75V1.75024H4.375C4.9 1.75024 5.25 1.40024 5.25 0.875244C5.25 0.350244 4.9 0.000244141 4.375 0.000244141H1.75C0.783125 0.000244141 0 0.783369 0 1.75024V12.2502C0 13.2171 0.783125 14.0002 1.75 14.0002H12.25C13.2169 14.0002 14 13.2171 14 12.2502V9.62524C14 9.10024 13.65 8.75024 13.125 8.75024Z"
        fill="currentColor"
      />
      <path
        d="M11.1187 0.256624C10.7765 -0.0855007 10.2235 -0.0855007 9.88142 0.256624L4.63142 5.50662C4.51942 5.61862 4.43979 5.7595 4.40129 5.91262L3.52629 9.41262C3.45104 9.711 3.53942 10.026 3.75642 10.2439C3.92179 10.4101 4.14579 10.5002 4.37504 10.5002C4.44592 10.5002 4.51679 10.4915 4.58679 10.474L8.08679 9.599C8.24079 9.5605 8.38167 9.48087 8.49367 9.36887L13.7437 4.11887C14.0858 3.77675 14.0858 3.22375 13.7437 2.88162L11.1187 0.256624ZM7.42704 7.96012L5.57729 8.42212L6.04017 6.57237L10.5 2.1125L11.8878 3.50025L7.42704 7.96012Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
